import axios from "axios";
import history from "../Helper/history";
import { SessionExpiredAlert, toastEmmit } from "../Helper/Toastr";

// Common GET API
export const GetService = async (url, params) => {
  // const navigate = useNavigate()

  const token = localStorage.getItem("token");

  if (!url) {
    return;
  }

  const axiosConfig = {
    headers: {
      Accept: "application/json",
      "x-access-token-web": token,
    },
    ...params,
  };

  try {
    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.clear()
      // navigate("/home");
      // history.push("/home");
      // window.location.reload()  

      SessionExpiredAlert(navigatetoHome)

      // try {
      //   await RefreshToken(token);
      //   // Retry the original request
      //   return await axios.get(url, axiosConfig);
      // } catch (refreshError) {
      //   // Handle refresh error (e.g., redirect to login page or display error message)
      //   console.log('Token refresh failed:', refreshError); 
      //   throw refreshError;
      // }
    }
    return error?.response;
  }
};

function navigatetoHome() {
  history.push("#/home");
  window.location.reload()
}


// Common POST API for JSON data
export const PostService = async (url, data) => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      "x-access-token-web": token,
    },
  };

  try {
    const response = await axios.post(url, data, axiosConfig);
    console.log(response)
    return response;
  } catch (error) {
    console.log(error)
    if (error?.response?.status === 401 || error?.response?.status === 403) {  
      localStorage.removeItem("token");
      localStorage.clear()
      SessionExpiredAlert(navigatetoHome) 
    }else{ 
      toastEmmit("error", error?.response?.data?.message?error?.response?.data?.message:error?.message)
      return error?.response;
    }
  }
};

// Common POST API for FormData
export const PostFormData = async (url, data) => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-access-token-web": token,
    },
  };

  try {
    const response = await axios.post(url, data, axiosConfig);
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      // console.log(error)
      // toastEmmit("error", error?.response?.data?.message)
      localStorage.removeItem("token");
      localStorage.clear()
      SessionExpiredAlert(navigatetoHome)
      // history.push("/home");
      // window.location.reload()
    }
    return error?.response;
  }
};


// const RefreshToken = async (token) => {
//   try { 
//     const response = await axios.post('/refresh-token', { oldToken: token }); 
//     localStorage.setItem('token', response.data.accessToken);
//   } catch (error) { 
//     throw new Error('Token refresh failed');
//   }
// };


// Common PUT API for JSON data
export const PutService = async (url, data) => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      "x-access-token-web": token,
    },
  };

  try {
    const response = await axios.put(url, data, axiosConfig);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      history.push("/home");
      window.location.reload()
    }
    return error.response;
  }
};

// Common PUT API for FormData
export const PutFormData = async (url, data) => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-access-token-web": token,
    },
  };

  try {
    const response = await axios.put(url, data, axiosConfig);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      history.push("/home");
      window.location.reload()
    }
    return error.response;
  }
};

// Common DELETE API
export const DeleteService = async (url, params) => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Accept: "application/json",
      "x-access-token-web": token,
      ...params,
    },
  };

  try {
    const response = await axios.delete(url, axiosConfig);
    return response;
  } catch (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      history.push("/home");
      window.location.reload()
    }
    return error.response;
  }
};
